import {
  BackgroundColors,
  PrimaryColors,
  TextColors,
} from '@picsart/design-system/foundation/colors';
import { FontSizes, LineHeights } from '@picsart/design-system/foundation/typography';

import { FontWeights } from '@picsart/design-system/foundation/fonts';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { createUseStyles } from 'react-jss';

import { BreakPoints } from '@picsart/design-system/foundation/responsive';
import { mediaQuery } from '@picsart/rc/helpers';

const useStyles = createUseStyles(
  () => ({
    root: {
      marginTop: Spacings.s24,
      marginBottom: Spacings.s40,
      // [mediaQuery(BreakPoints.Small)]: {
      '@media screen and (max-width: 766px)': {
        backgroundColor: BackgroundColors.base,
      },
    },
    wrapper: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      width: '100%',
      padding: [Spacings.s56, 110],
      backgroundColor: BackgroundColors.base,
      borderRadius: 34,
      '&.transparentBackground': {
        background: 'inherit',
      },

      [mediaQuery(BreakPoints.Large)]: {
        padding: [Spacings.s44, 80],
      },

      // [mediaQuery(BreakPoints.Small)]: {
      '@media screen and (max-width: 766px)': {
        padding: [Spacings.s56, Spacings.s0],
        maxWidth: 456,
        margin: [Spacings.s0, 'auto'],
      },
    },
    titleItemHolder: {
      textAlign: 'center',
      display: 'block',
    },
    title: {
      display: '-webkit-box',
      '-webkit-line-clamp': 2,
      '-webkit-box-orient': 'vertical',
      maxWidth: 856,
      margin: [Spacings.s0, 'auto'],
      fontSize: FontSizes.s30,
      fontWeight: FontWeights.semibold,
      overflow: 'hidden',
      lineHeight: LineHeights.l36,
      color: TextColors.tint1,

      [mediaQuery(BreakPoints.Large)]: {
        '-webkit-line-clamp': 3,
      },

      // [mediaQuery(BreakPoints.Small)]: {
      '@media screen and (max-width: 766px)': {
        '-webkit-line-clamp': 4,
      },

      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        '-webkit-line-clamp': 5,
        fontSize: Spacings.s24,
        lineHeight: LineHeights.l32,
      },
    },
    descItemHolder: {
      textAlign: 'center',
      display: 'block',
      '& a': {
        color: PrimaryColors.base.default,
      },

      '&.extra-space': {
        marginTop: Spacings.s24,

        [mediaQuery(BreakPoints.Large)]: {
          marginTop: Spacings.s16,
        },

        // [mediaQuery(767)]: {
        '@media screen and (max-width: 767px)': {
          marginTop: Spacings.s8,
        },
      },
    },
    desc: {
      display: '-webkit-box',
      '-webkit-line-clamp': 8,
      '-webkit-box-orient': 'vertical',
      fontSize: FontSizes.s16,
      fontWeight: FontWeights.normal,
      lineHeight: LineHeights.l24,
      overflow: 'hidden',
      color: TextColors.tint1,

      [mediaQuery(BreakPoints.Large)]: {
        '-webkit-line-clamp': 10,
      },

      // [mediaQuery(BreakPoints.Small)]: {
      '@media screen and (max-width: 766px)': {
        '-webkit-line-clamp': 15,
      },

      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        '-webkit-line-clamp': 22,
        fontSize: FontSizes.s14,
        lineHeight: LineHeights.l20,
      },
    },
    actionInnerHolder: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    actionItemHolder: {
      display: 'block',

      '&.extra-space': {
        marginTop: Spacings.s32,

        // [mediaQuery(767)]: {
        '@media screen and (max-width: 767px)': {
          marginTop: Spacings.s24,
        },
      },
    },
    action: {
      padding: [Spacings.s16, Spacings.s32],
      fontWeight: FontWeights.medium,
    },

    //  SKELETON

    titleFallback: {
      height: 40,
      width: 458,
    },
    descFallback: {
      height: 80,
      width: '100%',
    },
    buttonFallback: {
      height: 54,
      width: 240,
      marginTop: Spacings.s24,
    },
  }),
  {
    name: 'intro-text',
  },
);

export default useStyles;
